<template>
  <task-list-archive :filter-status="filter.archive" :values-blocks="['archive']"></task-list-archive>
</template>

<script>
import taskListArchive from '@/components/TaskListArchive'
import { mapState } from 'pinia/dist/pinia'
import { useTasksStore } from '@/stores/tasks'

export default {
  name: 'PageArchive',
  components: {
    taskListArchive,
  },
  data () {
    return {

    }
  },
  computed: {
    ...mapState(useTasksStore, ['filter']),
  },
  methods: {

  },
  mounted () {

  },
}
</script>
